import styled from "styled-components"

export const ImageContainer = styled.div`
  height: 189px;
  margin-bottom: 1%;
  width: 100%;
  display: flex;
  justify-content: center;
`

export const Title = styled.div`
  text-align: center;
  display: flex;
  justify-content: center;
  font-size: 18px;
  font-weight: bold;
`
